import { Component, OnInit, Input, Output, Inject, EventEmitter } from '@angular/core';

import { FacturationService } from '~Services/facturation.service';

import { BaseComponent } from '~Interfaces/basecomponent';

/**
 * Composant de factures
 * @extends BaseComponent
 * @implements OnInit
 */
@Component({
  selector: 'app-factures',
  templateUrl: './factures.component.html',
  styleUrls: ['./factures.component.scss']
})
export class FacturesComponent extends BaseComponent implements OnInit {

    @Input() factures: any[] = [];
    @Output() change: EventEmitter<any[]> = new EventEmitter<any[]>();

    filtresTri: any[] = [];

    dirAsc: string = 'asc';
    dirDesc: string = 'desc';

    /**
     * Constructeur
     */
    constructor(@Inject(FacturationService) private facturationService: FacturationService) { super(); }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
    }

    /**
     * Télécharger une facture
     * @param facture
     */
    telecharger(facture) {
        let numeroFacture = facture.NumeroFacture;
        let typeSortieFacture = '';
        let codeFournisseur = facture.CodeFournisseur;
        this.facturationService.telechargerFacture(numeroFacture, codeFournisseur, typeSortieFacture);
    }

    /**
     * Afficher une facture
     * @param facture
     */
    afficher(facture) {
        let numeroFacture = facture.NumeroFacture;
        let typeSortieFacture = '';
        let codeFournisseur = facture.CodeFournisseur;
        this.facturationService.afficherFacture(numeroFacture, codeFournisseur, typeSortieFacture);
    }

    /**
     * Changer le filtre de tri
     * @param nom
     */
    changerFiltreTri(nom: string) {
        // Définir le filtre
        var val = this.filtresTri[nom];
        if (val) {
            if (val == this.dirAsc) {
                delete this.filtresTri[nom];
            }
            if (val == this.dirDesc) {
                this.filtresTri[nom] = this.dirAsc;
            }
        }
        else {
            this.filtresTri[nom] = this.dirDesc;
        }

        // Emit
        this.change.emit(this.filtresTri);
    }

    /**
     * Indique si le filtre de tri est descendant
     * @param nom
     */
    estFiltreTriDesc(nom: string): boolean {
        return this.filtresTri[nom] == this.dirDesc;
    }

    /**
     * Indique si le filtre de tri est ascendant
     * @param nom
     */
    estFiltreTriAsc(nom: string): boolean {
        return this.filtresTri[nom] == this.dirAsc;
    }
}
